import React from 'react';

interface Props {
    children: string | number;
}

const NumberWrapper = ({ children }: Props) => (
    <span dir="ltr">{children}</span>
);

export default NumberWrapper;
